<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { seats } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="seats.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading colspan="2" as="th">
            {{ seats.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <SectionsDetailsPdfElementsList
            v-if="seats.displayList"
            :elements="details.seats.list"
            :in-two-cols-from="seats.twoColumnsFrom"
          />

          <SectionsDetailsElementsTable
            v-if="seats.displayTable"
            :table="details?.seats.table"
          />
        </tbody>
      </table>
    </td>
  </tr>
</template>
